import React from "react";
import { withRouter, Link } from "react-router-dom";
import { FaTrashAlt } from "react-icons/fa";
import { Config } from "../../Config";

const HeaderCartItem = (props) => {
  return (
    <React.Fragment>
      {props.cartData.map((item, index) => {
        return (
          <div key={index} className="cartProductItems">
            <Link to={`products/${item.id}/${item.productName.replaceAll(" ", "-")}`} className="cartProductItemImage">
              <img src={item.productImage} alt={item.productName} />
            </Link>
            <div className="cartProductItemDetails">
              <Link
                to={`products/${item.id}/${item.productName.replaceAll(" ", "-")}`}
                className="cartProductItemTitle"
              >
                {item.productName}
              </Link>
              <p className="cartProductItemCount"> تعداد: {item.count} </p>
              <div className="priceAndDelete">
                <p className="cartProductItemAmount"> {Config.separate(item.unitPrice)} ریال </p>
                <FaTrashAlt className="deleteItem" onClick={() => props.deleteCartHandler(item)} />
              </div>
            </div>
          </div>
        );
      })}
    </React.Fragment>
  );
};

export default React.memo(withRouter(HeaderCartItem));
